const HOME_SERVICES_CATEGORIES = new Set([
    "hvac",
    "plumbing",
    "roofing",
    "landscaping",
    "cleaning",
    "electrical",
    "pest-control",
    "premium-contractor",
]);
export function isHomeServicesVerticalCategory(category) {
    return HOME_SERVICES_CATEGORIES.has(category);
}
function graphHaystack(graph) {
    const serviceNames = graph.services.map((service) => service.name).join(" ");
    return `${graph.business.businessName} ${graph.business.description ?? ""} ${serviceNames}`.toLowerCase();
}
function matchesAny(haystack, patterns) {
    return patterns.some((pattern) => pattern.test(haystack));
}
const CATEGORY_PATTERNS = {
    dental: [
        /\bdental\b/,
        /\bdentist\b/,
        /\borthodont/,
        /\binvisalign\b/,
        /\bteeth whitening\b/,
        /\boral surgery\b/,
        /\bperiodont/,
        /\bpediatric dentistry\b/,
    ],
    fitness: [
        /\bfitness\b/,
        /\bcoaching\b/,
        /\bpersonal training\b/,
        /\bstrength coach/,
        /\bonline coaching\b/,
        /\blose fat\b/,
        /\btransformation program\b/,
        /\bworkout program\b/,
    ],
    "real-estate": [
        /\breal estate\b/,
        /\brealty\b/,
        /\brealtor\b/,
        /\bhome valuation\b/,
        /\bbuyer representation\b/,
        /\blisting strategy\b/,
        /\bproperty listings?\b/,
        /\bneighborhood guide\b/,
        /\bproperty advisor\b/,
    ],
    restaurant: [
        /\brestaurant\b/,
        /\bdine-?in\b/,
        /\bcatering\b/,
        /\breservation\b/,
        /\bpickup orders?\b/,
        /\bmenu\b/,
        /\bbiryani\b/,
        /\bcafe\b/,
        /\bfood lovers\b/,
    ],
    ecommerce: [
        /\be-?commerce\b/,
        /\bproduct launch\b/,
        /\blaunch list\b/,
        /\breusable bottle\b/,
        /\bwater bottle\b/,
        /\binsulated\b.*\bbottle\b/,
        /\bhydration\b/,
        /\bemail signup\b/,
        /\bonline store\b/,
        /\bshop now\b/,
        /\badd to cart\b/,
        /\bproduct features\b/,
        /\blaunch offer\b/,
    ],
    nonprofit: [
        /\bnonprofit\b/,
        /\b501\(c\)/,
        /\bfood fund\b/,
        /\bcommunity food\b/,
        /\bgrocery boxes?\b/,
        /\bpantry support\b/,
        /\bmeal deliveries\b/,
        /\bsenior meal\b/,
        /\bdonate to\b/,
        /\bdonation campaign\b/,
        /\bvolunteer this month\b/,
        /\bvolunteers?\b.*\bcommunity\b/,
        /\bcommunity\b.*\bvolunteers?\b/,
    ],
    hvac: [/\bhvac\b/, /\bheating and cooling\b/, /\bfurnace\b/, /\bair conditioning\b/, /\bac repair\b/],
    plumbing: [/\bplumb/, /\bdrain cleaning\b/, /\bwater heater\b/, /\bleak detection\b/],
    roofing: [/\broof/, /\bshingle\b/, /\bgutter\b/, /\bstorm damage\b/],
    landscaping: [/\blandscap/, /\blawn care\b/, /\byard care\b/, /\bmulch\b/],
    cleaning: [/\bhome cleaning\b/, /\bhousekeeping\b/, /\bmove-out cleaning\b/, /\bdeep cleaning\b/],
    electrical: [/\belectrical\b/, /\belectrician\b/, /\bpanel upgrade\b/, /\bceiling fan\b/],
    "pest-control": [/\bpest control\b/, /\bexterminator\b/, /\bperimeter treatment\b/],
    "premium-contractor": [
        /\bremodel/,
        /\brenovation\b/,
        /\bcontractor\b/,
        /\bkitchen refresh\b/,
        /\bbath update\b/,
    ],
};
const CATEGORY_ORDER = [
    "dental",
    "fitness",
    "real-estate",
    "restaurant",
    "ecommerce",
    "nonprofit",
    "hvac",
    "plumbing",
    "roofing",
    "landscaping",
    "cleaning",
    "electrical",
    "pest-control",
    "premium-contractor",
];
/**
 * Infer vertical category from business name, description, and service names.
 * Order is intentional — dental before cleaning, fitness before generic coaching-adjacent contractor copy.
 */
export function inferVerticalCategoryFromGraph(graph) {
    const haystack = graphHaystack(graph);
    for (const category of CATEGORY_ORDER) {
        if (matchesAny(haystack, CATEGORY_PATTERNS[category])) {
            return category;
        }
    }
    return "unknown";
}
//# sourceMappingURL=resolve-vertical-category.js.map